import React, { Component } from 'react';
import Particles from 'react-particles-js';
import Header from '../../components/main.header.component.js';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header
          props={this.props}
        />
        <div className="Particles">
          <Particles params={{
              "particles": {
                "number": {
                  "value": 104,
                  "density": {
                    "enable": true,
                    "value_area": 1122.388442605866
                  }
                },
                "color": {
                  "value": "#ffffff"
                },
                "shape": {
                  "type": "circle",
                  "stroke": {
                    "width": 0,
                    "color": "#e3c6c9"
                  },
                },
                "opacity": {
                  "value": 0.4655971085630409,
                  "random": true,
                  "anim": {
                    "enable": true,
                    "speed": 1.2,
                    "opacity_min": 0,
                    "sync": false
                  }
                },
                "size": {
                  "value": 2,
                  "random": true,
                  "anim": {
                    "enable": false,
                    "speed": 4,
                    "size_min": 0.3,
                    "sync": false
                  }
                },
                "line_linked": {
                  "enable": true,
                  "distance": 174,
                  "color": "#ffffff",
                  "opacity": 0.3367165327817598,
                  "width": 0
                },
                "move": {
                  "enable": true,
                  "speed": 1,
                  "direction": "bottom-left",
                  "random": true,
                  "straight": false,
                  "out_mode": "bounce",
                  "bounce": false,
                  "attract": {
                    "enable": false,
                    "rotateX": 600,
                    "rotateY": 600
                  }
                }
              },
              "interactivity": {
                "detect_on": "canvas",
                "events": {
                  "onhover": {
                    "enable": false,
                    "mode": "grab"
                  },
                  "onclick": {
                    "enable": true,
                    "mode": "repulse"
                  },
                  "resize": true
                },
                "modes": {
                  "grab": {
                    "distance": 400,
                    "line_linked": {
                      "opacity": 1
                    }
                  },
                  "bubble": {
                    "distance": 250,
                    "size": 0,
                    "duration": 2,
                    "opacity": 0,
                    "speed": 3
                  },
                  "repulse": {
                    "distance": 227.38161944437664,
                    "duration": 1
                  },
                  "push": {
                    "particles_nb": 4
                  },
                  "remove": {
                    "particles_nb": 2
                  }
                }
              },
              "retina_detect": true }} />
        </div>
        <div className="menu">
          <nav className="header-effect">
            <a href="https://github.com/cozpon" target='_blank' rel="noopener noreferrer">
              <span data-hover="Github">Github.</span>
            </a>
          </nav>
          <nav className="header-effect">
            <a href="https://medium.com/@rickyapeters" target='_blank' rel="noopener noreferrer">
              <span data-hover="Medium">Medium.</span>
            </a>
          </nav>
          <nav className="header-effect">
            <a href="https://www.linkedin.com/in/ricky-peters/" target='_blank' rel="noopener noreferrer">
              <span data-hover="LinkedIn">LinkedIn.</span>
            </a>
          </nav>
        </div>

        <div className="main-text">
          Welcome to the digital studio of Ricky Peters.
          <br />
          <br />
          <br />
          This site was built using React, Redux, Node.js and Express.
        </div>
      </div>
    );
  }
}

export default App;

